import type { MemberRole, TeamRole } from '@/data-sources/contract';

/** Whether this person may invite at all. v2 refuses a USER ("User is not admin"). */
export function canInvite(inviter: MemberRole): boolean {
  return inviter !== 'user';
}

/**
 * The roles this person may hand out, as v2 enforces them: only a super admin
 * makes another super admin; an admin makes admins and users.
 */
export function invitableRoles<R extends { value: TeamRole }>(
  roles: readonly R[],
  inviter: MemberRole,
): R[] {
  if (inviter === 'super-admin') return [...roles];
  if (inviter === 'admin') return roles.filter((role) => role.value !== 'super-admin');
  return [];
}
